import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Arrow, Header } from "../../components/SiteChrome";
import "./styles.scss";

const contactLinks = [
  { number: "01", name: "Email", detail: "alexandre@toubiana.dev", href: "mailto:alexandre@toubiana.dev" },
  { number: "02", name: "LinkedIn", detail: "/in/alexandre-toubiana", href: "https://www.linkedin.com/in/alexandre-toubiana" },
  { number: "03", name: "X", detail: "@alex_toubiana", href: "https://x.com/alex_toubiana" }
];

const ContactPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Contact — Alexandre Toubiana";
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <div className="v2-site contact-page" id="top">
      <a className="skip-link" href="#contact-main">Skip to content</a>
      <Header />

      <main className="contact-main" id="contact-main">
        <div className="contact-kicker"><span>CONTACT / 01—03</span><span>ALWAYS HAPPY TO HEAR FROM YOU</span></div>
        <div className="contact-intro">
          <h1>Say<br className="contact-title-break" /> hello<span>.</span></h1>
          <p>Questions, feedback, or just a hello? Pick a way to reach me.</p>
        </div>
        <div className="contact-links" aria-label="Ways to contact Alexandre">
          {contactLinks.map(({ number, name, detail, href }) => (
            <a className="contact-link" href={href} key={name} {...(href.startsWith("https:") ? { target: "_blank", rel: "noreferrer" } : {})}>
              <span className="contact-link-number">{number}</span>
              <span className="contact-link-name">{name}</span>
              <span className="contact-link-detail">{detail}</span>
              <Arrow diagonal />
            </a>
          ))}
        </div>
      </main>

      <footer className="contact-footer"><span>Alexandre Toubiana <span className="brand-period">.</span></span><Link to="/">Back to the work <Arrow diagonal /></Link></footer>
    </div>
  );
};

export default ContactPage;
